/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityLockOpenIcon16Light } from './SecurityLockOpenIcon16Light';
import { SecurityLockOpenIcon16Regular } from './SecurityLockOpenIcon16Regular';
import { SecurityLockOpenIcon16Solid } from './SecurityLockOpenIcon16Solid';
import { SecurityLockOpenIcon20Light } from './SecurityLockOpenIcon20Light';
import { SecurityLockOpenIcon20Regular } from './SecurityLockOpenIcon20Regular';
import { SecurityLockOpenIcon20Solid } from './SecurityLockOpenIcon20Solid';
import { SecurityLockOpenIcon24Regular } from './SecurityLockOpenIcon24Regular';
import { SecurityLockOpenIcon24Solid } from './SecurityLockOpenIcon24Solid';
import { SecurityLockOpenIcon32Regular } from './SecurityLockOpenIcon32Regular';
import { SecurityLockOpenIcon64Regular } from './SecurityLockOpenIcon64Regular';
var sizes = {
    16: {
        light: SecurityLockOpenIcon16Light,
        regular: SecurityLockOpenIcon16Regular,
        solid: SecurityLockOpenIcon16Solid,
    },
    20: {
        light: SecurityLockOpenIcon20Light,
        regular: SecurityLockOpenIcon20Regular,
        solid: SecurityLockOpenIcon20Solid,
    },
    24: {
        regular: SecurityLockOpenIcon24Regular,
        solid: SecurityLockOpenIcon24Solid,
    },
    32: {
        regular: SecurityLockOpenIcon32Regular,
    },
    64: {
        regular: SecurityLockOpenIcon64Regular,
    },
};
export var SecurityLockOpenIcon = forwardRef('SecurityLockOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
